// AI Brasil Membership - Plano Único
export const membership = {
  name: "AI Brasil Membership Oficial",
  tagline: "Espaços Exclusivos para Verdadeiros Membros",
  description: "Colaboração, construção e conexões reais. Juntos somos mais fortes.",
  monthlyPrice: 29,
  annualPrice: 290,
  ctaUrl: "https://ai.eco.br/plans/1993903?bundle_token=9f56ca8594ca57a7807f075dee383f2a&utm_source=manual",
  freeCtaUrl: "https://ai.eco.br/plans/1979445?bundle_token=aea96ac88a1205364ce25700e36d44d7&utm_source=manual",
  benefits: [
    {
      icon: "Users",
      title: "Rede Ativa de Conexões",
      description: "Acesse uma rede viva de profissionais, empreendedores e líderes reais que trabalham com IA no Brasil."
    },
    {
      icon: "Sparkles",
      title: "Espaços Exclusivos",
      description: "Grupos temáticos, regionais e de interesse onde você conecta com quem faz sentido pra você."
    },
    {
      icon: "Calendar",
      title: "Eventos Presenciais e Online",
      description: "Meetups, workshops, imersões e encontros exclusivos em todo o Brasil."
    },
    {
      icon: "TrendingUp",
      title: "Oportunidades Reais",
      description: "Vagas, parcerias, projetos, investimentos e negócios que surgem naturalmente."
    },
    {
      icon: "Award",
      title: "Reconhecimento e Reputação",
      description: "Sua participação ativa é valorizada com badges, destaques e visibilidade real."
    },
    {
      icon: "BookOpen",
      title: "Conteúdo Curado",
      description: "Materiais, cursos, mentorias e discussões sobre o que realmente importa em IA."
    }
  ]
};

// Espaços Temáticos
export const thematicSpaces = [
  {
    name: "IA em Saúde",
    description: "Aplicações de IA em medicina, diagnóstico e healthtech",
    icon: "Heart",
    members: "1.2K+",
    color: "green"
  },
  {
    name: "IA em Finanças",
    description: "FinTech, algorithmic trading e IA para investimentos",
    icon: "TrendingUp",
    members: "980+",
    color: "gold"
  },
  {
    name: "IA em Educação",
    description: "EdTech, aprendizado adaptativo e tutoria com IA",
    icon: "GraduationCap",
    members: "1.5K+",
    color: "green"
  },
  {
    name: "IA em Marketing",
    description: "MarTech, personalização e campanhas com IA generativa",
    icon: "Megaphone",
    members: "2.1K+",
    color: "green"
  },
  {
    name: "Prompt Engineering",
    description: "Técnicas avançadas de prompt para LLMs",
    icon: "Terminal",
    members: "3.4K+",
    color: "gold"
  },
  {
    name: "LLMs e Modelos",
    description: "Discussões sobre GPT, Claude, Gemini e modelos open-source",
    icon: "Brain",
    members: "2.8K+",
    color: "green"
  },
  {
    name: "IA e Ética",
    description: "Debates sobre viés, regulação e IA responsável",
    icon: "Shield",
    members: "890+",
    color: "gold"
  },
  {
    name: "Startups de IA",
    description: "Founders, investidores e aceleradoras de IA",
    icon: "Rocket",
    members: "1.7K+",
    color: "green"
  },
  {
    name: "Computer Vision",
    description: "Visão computacional, OCR e processamento de imagens",
    icon: "Eye",
    members: "1.1K+",
    color: "gold"
  }
];

// Espaços Regionais
export const regionalSpaces = [
  { name: "São Paulo", members: "4.2K+", meetups: "Mensais" },
  { name: "Rio de Janeiro", members: "2.8K+", meetups: "Mensais" },
  { name: "Belo Horizonte", members: "1.5K+", meetups: "Bimestrais" },
  { name: "Porto Alegre", members: "1.3K+", meetups: "Mensais" },
  { name: "Curitiba", members: "1.1K+", meetups: "Mensais" },
  { name: "Recife", members: "980+", meetups: "Bimestrais" },
  { name: "Brasília", members: "890+", meetups: "Mensais" },
  { name: "Florianópolis", members: "760+", meetups: "Mensais" },
  { name: "Salvador", members: "650+", meetups: "Trimestrais" },
  { name: "Fortaleza", members: "580+", meetups: "Trimestrais" },
  { name: "Manaus", members: "420+", meetups: "Trimestrais" },
  { name: "Campinas", members: "540+", meetups: "Bimestrais" }
];

// Quiz - Adaptado para focar em Membership vs Gratuito
export const quizQuestions = [
  {
    id: 1,
    question: "Qual é a sua intenção ao entrar no maior ecossistema de IA do Brasil?",
    options: [
      { id: "a", text: "Quero apenas explorar e conhecer o ecossistema", recommendation: "free" },
      { id: "b", text: "Quero me conectar de verdade e construir junto", recommendation: "member" },
      { id: "c", text: "Quero gerar negócios e oportunidades reais", recommendation: "member" },
      { id: "d", text: "Quero visibilidade, reconhecimento e networking premium", recommendation: "member" }
    ]
  },
  {
    id: 2,
    question: "Quanto você valoriza conexões humanas reais na sua jornada?",
    options: [
      { id: "a", text: "Estou começando, quero primeiro entender", recommendation: "free" },
      { id: "b", text: "Muito - quero fazer parte ativamente", recommendation: "member" },
      { id: "c", text: "É prioridade - estou pronto para participar", recommendation: "member" },
      { id: "d", text: "É essencial - quero estar no centro do movimento", recommendation: "member" }
    ]
  },
  {
    id: 3,
    question: "Você prefere ser um espectador ou um construtor?",
    options: [
      { id: "a", text: "Espectador por enquanto", recommendation: "free" },
      { id: "b", text: "Quero começar a participar", recommendation: "member" },
      { id: "c", text: "Sou construtor - quero criar valor", recommendation: "member" },
      { id: "d", text: "Sou líder - quero impactar e ser reconhecido", recommendation: "member" }
    ]
  }
];

// Depoimentos
export const testimonials = [
  {
    name: "Marina Silva",
    role: "Desenvolvedora Full Stack",
    quote: "Ser membro me trouxe conexões que mudaram minha carreira. Consegui uma vaga incrível através de alguém que conheci em um meetup.",
    image: "https://customer-assets.emergentagent.com/job_ai-brasil-plans/artifacts/pa4a3psm_LAPA%2002-10-2025%203.jpg"
  },
  {
    name: "Carlos Santos",
    role: "Fundador de Startup",
    quote: "Encontrei meu co-fundador e nosso primeiro investidor. O membership vale cada centavo pela rede que construí.",
    image: "https://customer-assets.emergentagent.com/job_ai-brasil-plans/artifacts/6dnckhe7_%40BabiOtero_AIExperienceDia1_-343%20%281%29.jpg"
  },
  {
    name: "Ana Paula",
    role: "Head de Inovação",
    quote: "Não é só uma comunidade. É o lugar onde as coisas realmente acontecem no ecossistema de IA do Brasil.",
    image: "https://customer-assets.emergentagent.com/job_ai-brasil-plans/artifacts/0b57bhw3_Imagem%20do%20WhatsApp%20de%202025-08-04%20%C3%A0%28s%29%2017.18.03_bb0277a4.jpg"
  }
];

// Event Photos - imagens de alto impacto
export const eventPhotos = [
  {
    url: "https://customer-assets.emergentagent.com/job_ai-brasil-plans/artifacts/4nfxxgsj_1771939942545.jpg",
    caption: "Grande evento nacional com bandeira do Brasil"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_ai-brasil-plans/artifacts/njnobmov_WhatsApp%20Image%202026-03-29%20at%2019.30.59%20%281%29.jpeg",
    caption: "Painel de Governança e Gestão de Riscos da IA"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_ai-brasil-plans/artifacts/pa4a3psm_LAPA%2002-10-2025%203.jpg",
    caption: "Palestrantes especialistas em IA"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_ai-brasil-plans/artifacts/6dnckhe7_%40BabiOtero_AIExperienceDia1_-343%20%281%29.jpg",
    caption: "Networking em eventos exclusivos"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_ai-brasil-plans/artifacts/0b57bhw3_Imagem%20do%20WhatsApp%20de%202025-08-04%20%C3%A0%28s%29%2017.18.03_bb0277a4.jpg",
    caption: "Comunidade unida e engajada"
  }
];
